/**
 * Handles the "MusicMode" packet
 * @param {Array} args packet arguments
 */
export const handleMM = (_args: string[]) => {
  // It's unused nowadays, as preventing people from changing the music is now serverside
};
